module.exports = __webpack_public_path__ + "media/western-osprey-1.726444a3.mp3";